import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { QuickFilter } from '../../types';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import PriceRangeFilter from './PriceRangeFilter';
import SelectionFilter from './SelectionFilter';
import FilterActions from './FilterActions';
import DeliveryFilter from './DeliveryFilter';

const FilterOptionsDropdown = () => {
  const quickFilter = useSelector((state: any) => state.map.quickFilter);

  const renderDropdown = useCallback(() => {
    if (quickFilter === QuickFilter.PRICE) {
      return <PriceRangeFilter />;
    }

    if (quickFilter === QuickFilter.PROPERTY_TYPE) {
      return <SelectionFilter filterType={SearchFiltersTypes.PROPERTY_TYPES} />;
    }

    if (quickFilter === QuickFilter.DELIVERY) {
      return <DeliveryFilter />;
    }
  }, [quickFilter]);

  return (
    <Container className="hide-scrollbar">
      {renderDropdown()}

      <FilterActions />
    </Container>
  );
};

const Container = styled.div`
  min-width: 285px;
  display: flex;
  flex-direction: column;
  max-height: 480px;
  align-items: center;
  padding: 16px;
  padding-bottom: 0;
  gap: 8px;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 53px;
  inset-inline-start: 0;
  overflow-y: auto;
  z-index: 9999999;
`;

export default FilterOptionsDropdown;
